// extracted by mini-css-extract-plugin
module.exports = {"HeadingWrapper":"styles_HeadingWrapper__1kLI1"};